export default {
  downloadApp: {
    title: "Descargá la app",
    body: "Llevá {{brand}} siempre con vos. Gestioná tus turnos desde la app y mantente al día estés donde estés.",
    cancel: "Cancelar",
    learnMore: "Saber más",
  },
  nav: {
    features: "Características",
    about: "Nosotros",
    contact: "Contacto",
    faqs: "FAQs",
    register: "Registro",
    access: "Acceso",
  },
  hero: {
    title: "La plataforma integral para profesionales de la salud",
    subtitle:
      "¡Bienvenido a {{brand}}! La plataforma responsive (multi-dispositivo) donde todo está a tu disposición, eliges lo que quieres.",
    cta: "Solicitá una demo",
  },
  features: {
    title: "Funciones",
    appointments: {
      title: "Gestión de Turnos",
      description:
        "Organizá tu agenda con facilidad. Confirmaciones automáticas por WhatsApp.",
    },
    records: {
      title: "Historias Clínicas Digitales",
      description:
        "Accedé a los antecedentes de tus pacientes en cualquier momento, desde cualquier lugar.",
    },
    security: {
      title: "Privacidad y Seguridad",
      description:
        "Cumplimos con los más altos estándares para resguardar tus datos y los de tus pacientes.",
    },
    extraTitle: "Funciones adicionales",
    extraItems: [
      "Notificaciones",
      "Compartir agenda (día/s y horario/s) con instituciones",
      "Turnos por obra social y privados",
      "Cobros por Mercado Pago",
      "Recepción de pacientes",
      "Consentimiento informado con templates/plantillas para realizar el tuyo personalizado",
      "Facturación por ARCA",
      "Agregar secretarias (ilimitadas)",
      "Inventario: Manejo de stock, quiebre de stock, avisos, costos de insumos y más.",
      "Tratamientos",
      "Y vamos a continuar agregando más funciones…",
    ],
  },
  about: {
    eyebrow: "Sobre nosotros",
    title: "Quiénes somos",
    philosophy: {
      title: "Nuestra filosofía",
      body: "En medicina no hay nada mejor como la interacción PERSONAL, a pesar de ofrecerte una solución digital. Somos una familia de médicos, programadores, administradores y pacientes que nos propusimos ofrecer herramientas con un costo-beneficio fuera de lo tradicional.",
    },
    approach: {
      title: "Nuestro enfoque",
      body: "Claros y concretos en cuanto a lo que ofrecemos… tenés todo lo usás lo que querés. Sin sorpresas, sin abonar de más. Comunicamos de forma directa, sin necesidad de leer entre líneas, y estamos presentes para ayudarte en lo que precises.",
    },
    commitment: {
      title: "Nuestro compromiso",
      body: "El profesional puede tener la fluidez adecuada en su consultorio, ganando contratiempos y enfocarse en el diagnóstico, tratamiento, seguimiento u otra patología que el paciente presente mediante la omnicanalidad de nuestra infraestructura. Valoramos tu tiempo y el de nuestro equipo. Nuestra solución se desarrolló con tecnologías modernas con fuerte hincapié en UX e UI para brindar utilidad al profesional y paciente.",
    },
    closing: "¡Agradecemos el tiempo dedicado y esperemos conocernos pronto!",
  },
  faqs: {
    eyebrow: "Preguntas Frecuentes",
    title: "FAQs",
    moreQuestions: "¿Tenes mas consultas? ¡ Escríbenos !",
    contactUs: "Contactanos",
    items: [
      {
        question: "¿Para quién está dirigido la plataforma?",
        answer:
          "Para médicos independientes, médicos que atienden en varios lugares, consultorios y poli consultorios chicos, medianos y grandes. También para aquellas instituciones que deseen tercerizar ciertos aspectos de la diaria que les quita productividad.",
      },
      {
        question: "Si no soy médico, ¿puedo registrarme y usar la plataforma con mis clientes?",
        answer:
          "No. Validamos cada matrícula de cada perfil médico, garantizando idoneidad profesional. Podemos recomendarte otras aplicaciones si no eres médico.",
      },
      {
        question: "¿Puedo usar algunas funciones o tengo que usar todas?",
        answer:
          "Es simple, tenes todo y usas lo que queres. No se cobra por demás o menos por el uso de determinadas funciones.",
      },
      {
        question: "¿Están seguros mis datos?",
        answer:
          "Siempre, la información se encuentra almacenada en servidores de última generación encriptados y en permanente actualización. Podes ver más en nuestros términos y condiciones (links a las páginas).",
      },
      {
        question: "¿Ofrecen soporte o ayuda?",
        answer:
          "¡Por supuesto! Nuestros canales de atención son por mail, celular o WhatsApp. ¡Como prefieras!",
      },
      {
        question: "¿Qué necesito para instalar o usar la plataforma?",
        answer:
          "La podes usar o instalar en tu smartphone, tablet o computadora. Lo único que necesitas es acceso a internet.",
      },
      {
        question: "¿Es necesario hacer un curso para instalarlo?",
        answer:
          "¡Para nada! La plataforma es súper intuitiva, de fácil configuración y bajo tiempo de instalación. Indistintamente de todo, si no podes avanzar con algo nuestros canales de atención están para ayudarte.",
      },
      {
        question: "¿Qué es un Perfil Institución?",
        answer:
          "Perfil que puede nuclear a varios médicos y secretarias. Permite tener una estructura en un lugar donde atienden varios profesionales con diversos horarios y distintos asistentes. Puede modificarse el horario del profesional, siempre que éste lo comparta, secretarias e información de contacto de la institución. Recomendamos utilizar este perfil a partir de un consultorio con dos médicos.",
        image: "/images/perfil-institucion.png",
        imageAlt: "Perfil Institución",
      },
      {
        question: "¿Descripción Perfil Médico?",
        answer:
          "El perfil más importante, sin éste, no vas a poder utilizar la institución, secretarias y demás funciones.",
        image: "/images/perfil-medico.png",
        imageAlt: "Perfil Médico",
      },
      {
        question: "¿Puede el médico facturar sus honorarios a la institución?",
        answer:
          "¡Por supuesto! De acuerdo a la situación fiscal del profesional, puede realizarle la debida facturación.",
      },
      {
        question: "¿A quién se le cobra?",
        answer:
          "Se cobra únicamente al perfil médico. El resto de los usuarios no paga por usar la aplicación o funciones.",
      },
      {
        question: "¿Cuál es la forma de pago?",
        answer: "El cobro es mensual por débito automático de Mercado Pago.",
      },
      {
        question: "¿Ofrecen días de prueba sin cargo?",
        answer:
          "¡Por supuesto! Luego de completar la información solicitada y realizar la suscripción, tienes automáticamente 15 días sin cargo. Puedes desuscribirte cuando quieras, eso sí, si decides regresar no tendrás los días sin cargo.",
      },
      {
        question: "¿A qué tipo de dólar se cobra?",
        answer:
          "Para médicos de Argentina, al dólar del Banco Nación cotización billete compra.\n\nPara médicos fuera de Argentina, de acuerdo a la cotización del tipo de cambio a Pesos Argentinos del banco de su país.",
      },
      {
        question: "¿Hacen Factura A?",
        answer: "Si, realizamos factura A si así lo deseas.",
      },
      {
        question: "Somos un montón en la clínica, ¿hacen descuentos?",
        answer:
          "Éste tipo de situaciones las evaluamos caso por caso pero siempre nos gusta acompañarlos en su camino, consultamos y vas a tener buenas noticias.",
      },
    ],
  },
  contact: {
    eyebrow: "Comunicate con nosotros",
    title: "Contacto",
    cta: "Solicitá una demo",
  },
};
